import { createDataTestSelector } from "../../createDataTestSelector";

export default {
  confirmOptOut: createDataTestSelector("metametrics-i-agree"),
};
